import Component from '@glimmer/component';

interface PrismLoadingBarSignature {
  Args:
    | {
        isFixed: true;
        positionTop: number;
      }
    | {
        isFixed?: false;
        positionTop?: number;
      };
  Element: HTMLDivElement;
}

export default class PrismLoadingBar extends Component<PrismLoadingBarSignature> {
  get styleForLoadingBar(): string {
    const { isFixed, positionTop } = this.args;

    return isFixed ? `top: ${positionTop}px;` : '';
  }

  <template>
    <div
      class="prism-loading-bar {{if @isFixed 'prism-loading-bar--fixed'}}"
      style={{this.styleForLoadingBar}}
      ...attributes
    >
      <div class="prism-loading-bar__indeterminate"></div>
    </div>
  </template>
}
